var randomId = function randomId() {
  return "_".concat(Math.random().toString(36).substr(2, 9));
};

export { randomId };
//# sourceMappingURL=randomId.js.map
